<ami-dialog-message [setting]="message"></ami-dialog-message>
<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event)"
></ami-table-actions>

<ami-dialog-confirm
  [setting]="confirmSettings"
  (confirmed)="actionConfirmed($event)"
></ami-dialog-confirm>

<div *ngIf="idDocument">
  <ami-detail-dialog
    [idDocument]="idDocument"
    (onHideData)="idDocument=undefined"
  >
  </ami-detail-dialog>
</div>